module.exports = __webpack_public_path__ + "static/img/nav4.4ba69163.svg";